import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Breadcrumb from '../../Common/Breadcrumb';
import { setInitialFilterConf } from '../../slices/filters/thunk';
import AttemptsList from './AttemptsList';
import AttemptReview from './AttemptReview';
import ImportWizard from './ImportWizard';
import { PAGE_TITLE, PARENT_TITLE } from './constants';

/**
 * The import tool: a list of attempts, one of which you may be in the middle of.
 *
 * All three views live on /import and are chosen by query param rather than by
 * sub-route, because the sidebar resolves its active item from the first path
 * segment only (Layouts/SidebarLayout.js getCurItem) -- a real sub-route would
 * un-highlight the menu entry the moment you opened an attempt.
 */
const StatementImport = () => {
  document.title = PAGE_TITLE + process.env.REACT_APP_PAGE_TITLE;

  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    // Nothing here is filtered by date or type -- and `data` is required or the
    // filters reducer logs an error.
    dispatch(setInitialFilterConf({ data: {}, hidden: ['*'] }));
  }, [dispatch]);

  const attemptId = Number(searchParams.get('attempt')) || null;
  const isNew = searchParams.get('new') === '1';

  const showList = () => setSearchParams({});
  const showNew = () => setSearchParams({ new: '1' });
  const showAttempt = (id) => setSearchParams({ attempt: String(id) });

  return (
    <>
      <Breadcrumb parentTitle={PARENT_TITLE} pageTitle={PAGE_TITLE} />

      {isNew && (
        <ImportWizard onCreated={showAttempt} onCancel={showList} />
      )}

      {!isNew && attemptId && (
        <AttemptReview
          key={attemptId}
          attemptId={attemptId}
          onBack={showList}
        />
      )}

      {!isNew && !attemptId && (
        <AttemptsList onOpen={showAttempt} onNew={showNew} />
      )}
    </>
  );
};

export default StatementImport;
